import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { transferEvals, prepopulateEvals, notesSchema } from '_services/_schemas';
import { getDateYYYYMMDD } from '_helpers';

export const noteService = {
    saveAddendum,
    deleteNote,
    reopenNote,
    startNote,
    startNoteScribe,
    transferEval,
    prepopulateEval,
    startBlankEval,
    prepopulateEvalScribe,
    startBlankEvalScribe,
    load,
    updateTextField,
    updateBitField,
    updateIntField,
    updateALTime,
    updateDecimalField,
    updateDateField,
    clearField,
    clearFields,
    clearSpineFields,
    addTemplate,
    removeTemplate,
    addChildRow,
    addCustomGoal,
    addCustomSTGoal,
    addIndHepGoal,
    addChildRowGenerator,
    addAlRow,
    removeChildRow,
    updateAlModField,
    updateAlOtherField,
    clearAl,
    getAlTemplate,
    getNoteWarnings,
    getStartNoteWarnings,
    applyAlTemplate,
    saveAlTemplate,
    deleteAlTemplate,
    undoDeleteAlTemplate,
    addGoal,
    favoriteGoal,
    applyFavoriteGoal,
    clearGoals,
    addSTGFlag,
    addAssessmentFlag,
    addPlanSubCat,
    updateAllAssessmentFlags,
    updateAllGoalFlags,
    clearAlGroup,
    computeCharges,
    checkDate,
    saveFinal,
    convert,
    saveObjectiveTemplate,
    updateAllShortGoalFlags,
    updateDatesLTG,
    updateDatesSTG,
    addGoalTemplates,
};

async function saveAddendum(noteId, addendum) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, addendum })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addendum', requestOptions, true);
}

async function deleteNote(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/delete', requestOptions, true);
}

async function reopenNote(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })

    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/reopennote', requestOptions, true);
}

async function getStartNoteWarnings(epno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/getstartnotewarnings?epno=' + epno, requestOptions, true)
}


async function startNote(epno, aptid, adtdate, noteType) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, aptid, adtdate, noteType })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/start', requestOptions, true)
        .then(data => {
            var flat = normalize(data, { transferEvals: [transferEvals], prepopulateEvals: [prepopulateEvals] });
            return flat;
        });
}

async function startNoteScribe(epno, thurno, aptid, adtdate, noteType) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, aptid, adtdate, noteType, thurno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/startScribe', requestOptions, true)
        .then(data => {
            var flat = normalize(data, { transferEvals: [transferEvals], prepopulateEvals: [prepopulateEvals] });
            return flat;
        });
}

async function transferEval(epno, noteId, aptid, adtdate, usePedsTemplate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, noteId, aptid, adtdate, usePedsTemplate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/transfereval', requestOptions, true);
}

async function prepopulateEval(epno, noteId, aptid, adtdate, usePedsTemplate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, noteId, aptid, adtdate, usePedsTemplate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/prepopulateeval', requestOptions, true);
}

async function prepopulateEvalScribe(epno, noteId, aptid, adtdate, thurno, usePedsTemplate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, noteId, aptid, adtdate, thurno, usePedsTemplate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/prepopulateevalscribe', requestOptions, true);
}

async function startBlankEval(epno, aptid, adtdate, usePedsTemplate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, aptid, adtdate, usePedsTemplate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/startblankeval', requestOptions, true);
}

async function startBlankEvalScribe(epno, aptid, adtdate, thurno, usePedsTemplate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, aptid, adtdate, thurno, usePedsTemplate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/startblankevalscribe', requestOptions, true);
}


async function load(noteId) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/load?noteId=' + noteId, requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function updateTextField(noteId, entity, entityKeyColumn, entityKeyValue, field, textValue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field, textValue })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatefield', requestOptions, true);
}

async function updateBitField(noteId, entity, entityKeyColumn, entityKeyValue, field, bitValue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field, bitValue })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatefield', requestOptions, true);
}

async function updateIntField(noteId, entity, entityKeyColumn, entityKeyValue, field, intValue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field, intValue })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatefield', requestOptions, true);
}

async function updateALTime(asTime, thTime, toTime, xlno, field) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        //body: JSON.stringify({ asTime, thTime, toTime, xlno, field })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatealtime?asTime=' + (asTime ?? '') + "&thTime=" + (thTime ?? '') + "&toTime=" + (toTime ?? '') + "&xlno=" + xlno + "&field=" + field, requestOptions, true);
}

async function updateDecimalField(noteId, entity, entityKeyColumn, entityKeyValue, field, decimalValue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field, decimalValue })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatefield', requestOptions, true);
}

async function updateDateField(noteId, entity, entityKeyColumn, entityKeyValue, field, dateValue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field, dateValue: getDateYYYYMMDD(dateValue) })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatefield', requestOptions, true);
}

async function clearField(noteId, entity, entityKeyColumn, entityKeyValue, field) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatefield', requestOptions, true);
}

async function clearFields(noteId, entity, entityKeyColumn, entityKeyValue, fields) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, fields })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/clearfields', requestOptions, true);
}

async function clearSpineFields(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/clearspinefields', requestOptions, true);
}


async function addTemplate(noteId, teno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, teno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addtemplate', requestOptions, true);
}

async function removeTemplate(noteId, teno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, teno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/removetemplate', requestOptions, true);
}

async function addChildRow(noteId, table, tablePrefix, parentKeyColumn, parentKeyValue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, table, tablePrefix, parentKeyColumn, parentKeyValue })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addchildrow', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });

}

async function addCustomGoal(noteId, isWc, goalDate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, isWc, goalDate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addcustomgoal', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });

}

async function addIndHepGoal(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addindhepgoal', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });

}

async function addChildRowGenerator(noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addchildrowgenerator', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });

}

async function addAlRow(noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, markAssistant, isSpeech) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, markAssistant, isSpeech })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addalrow', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });

}

async function removeChildRow(noteId, table, tablePrefix, pk) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, table, tablePrefix, pk })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/removechildrow', requestOptions, true);
}

async function updateAlModField(noteId, entity, entityKeyColumn, entityKeyValue, field, intValue, timed) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field, intValue, timed })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatealmodfield', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function updateAlOtherField(noteId, entity, entityKeyColumn, entityKeyValue, field, intValue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, entity, entityKeyColumn, entityKeyValue, field, intValue })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatealotherfield', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function clearAl(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/clearal', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function getNoteWarnings(epno, noteID, date) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/getnotewarnings?epno=' + epno + '&noteID=' + noteID + '&date=' + date, requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function addGoalTemplates(noteId, goalsArray) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addgoaltempate?noteId=' + noteId + '&goalsArray=' + goalsArray, requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });

}

async function getAlTemplate(tmpno, noteId) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/getaltemplate?noteId=' + noteId + '&tmpno=' + tmpno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function applyAlTemplate(xlno, noteId, aqnos, ganos, manos, mdnos, nenos, oenos, scnos, sznos, tanos, tenos) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ xlno, noteId, aqnos, ganos, manos, mdnos, nenos, oenos, scnos, sznos, tanos, tenos })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/applyaltemplate', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });

}

async function saveAlTemplate(xlno, templateName) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ xlno, templateName })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/savealtemplate', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function deleteAlTemplate(noteId, tmpno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, tmpno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/deletealtemplate', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function undoDeleteAlTemplate(noteId, tmpno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, tmpno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/undodeletealtemplate', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function addCustomSTGoal(noteId, goalDate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, goalDate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addcustomstgoal', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function updateDatesLTG(noteId, defaultDate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ defaultDate, noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updatelonggoals', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function updateDatesSTG(noteId, defaultDate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ defaultDate, noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updateshortgoals', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function addGoal(noteId, activity, isFoto, goalDate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, activity, isFoto, goalDate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addgoal', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function favoriteGoal(noteId, gfname, gfmgno, gfcustom, gfgoallevel, gfobjective, gfworktask) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, gfname, gfmgno, gfcustom, gfgoallevel, gfobjective, gfworktask })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/savegoalfavorite', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function applyFavoriteGoal(noteId, gono, gfno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, gono, gfno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/applygoalfavorite', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function clearGoals(noteId, delReason) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, delReason })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/cleargoals', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function addSTGFlag(NoteID, FlagText, Custom, stgDate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ NoteID, FlagText, Custom, stgDate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addstgflag', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}


async function addAssessmentFlag(noteId, asno, mopno, flagText) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, asno, mopno, flagText })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addassessmentflag', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}


async function addPlanSubCat(noteId, plno, mdno, timed, oeno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, plno, mdno, timed, oeno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/addplansubcat', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function updateAllAssessmentFlags(noteId, asno, selected, type) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, asno, selected, type })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updateallassessmentflags', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}


async function updateAllShortGoalFlags(noteId, asno, selected, type) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, asno, selected, type })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updateallshortgoalflags', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function updateAllGoalFlags(noteId, asno, selected, type) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, asno, selected, type })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/updateallgoalflags', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function clearAlGroup(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/clearalgroup', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function computeCharges(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/computecharges', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function checkDate(noteId, epno, trtdate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, epno, trtdate })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/checkdate', requestOptions, true)
}

async function saveFinal(noteId, epno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, epno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/savefinal', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

async function convert(noteId, noteType) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, newNoteType: noteType })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/convert', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}


async function saveObjectiveTemplate(noteId, templateName) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, templateName })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/notes/saveobjectivetemplate', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesSchema);
            return flat;
        });
}

